import { fetchFilterOptionsConfigs } from "@/components/inputs/DynamicTagsInputs/FilterInput/configs";
import { getFilterType } from "@/components/inputs/DynamicTagsInputs/FilterInput/utils/getFilterType";
import { useCallback, useState, useMemo } from "react";

export const isLocalSearchFilterType = (filterConfig) => {
  if (filterConfig.frontendSearch === true) return true;
  const {filterType: actualFilterType} = getFilterType(filterConfig);
  return fetchFilterOptionsConfigs[actualFilterType].frontendSearch === true
}

export const useSearchMethod = ({ filterConfig, lightboxConfig, onSearchChange, debounce }) => {
  const [search, setSearch] = useState("");
  
  const isLocalSearch = useMemo(() => isLocalSearchFilterType(filterConfig), [filterConfig]);

  // Memoized filtered options for local search
  const filteredOptions = useMemo(() => {
    if (!isLocalSearch) {
      return null;
    }
    
    if (!search || search.trim() === "") {
      return null; // Return null to show all options
    }

    const searchLower = search.toString().toLowerCase();
    return lightboxConfig.props.options.filter(option => 
      //cuz sometimes display can be a number
      option.display.toString().toLowerCase().includes(searchLower)
    );
  }, [isLocalSearch, search, lightboxConfig.props.options]);

  const handleSearchChange = useCallback((searchTerm) => {
    setSearch(searchTerm);
    
    if (!isLocalSearch) {
      debounce(() => {
        onSearchChange && onSearchChange(searchTerm);
      });
    }
  }, [isLocalSearch, onSearchChange, debounce]);

  const resetSearch = useCallback(() => {
    setSearch("");
    // Reset search 
    onSearchChange && onSearchChange('');
  }, [onSearchChange]);

  return {
    search,
    filteredOptions,
    handleSearchChange,
    resetSearch,
  };
};